<template>
    <a class="button-exit" @click="exit" :class="{disabled: noshow === true}">
      <img src="media/global/btn_continue.png"/>
      <div class="button-title">{{this.$store.state.items.buttons.exitButton}}</div>
    </a>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    computed: {
      location () {
        return this.$store.state.scormLMS.location
      },
      noshow () {
        if (this.$store.state.scormLMS.location < 7) {
          return true
        } else return false
      }
    },
    methods: {
      exit() {
        console.log('TRAINING CONCLUDED. EXIT.') //^* Need to write exit function
      }
    },
    components: {},
    props: ['items']
  }

</script>

<style scoped>
.button-exit {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 990;
  cursor: pointer;
  user-select: none;
  -webkit-filter: drop-shadow(1.5px 1.5px 1px #222 );
  filter: drop-shadow(1.5px 1.5px 1px #222);
}
.button-exit.disabled {
  display: none;
  pointer-events: none;
}
.button-title {
  position: absolute;
  bottom: 6px;
  right: 40px;
  z-index: 999;
  font-size: 13px;
  text-decoration: none;
  color: black;
}

</style>



// WEBPACK FOOTER //
// ButtonExit.vue?79193532